webpackJsonp([18],{

/***/ "1i72":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("EQXP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6042b94b", content, true, {});

/***/ }),

/***/ "EQXP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".error-page[data-v-6c9ca486]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:100%;background:#f3f3f3;-webkit-box-sizing:border-box;box-sizing:border-box}.error-code[data-v-6c9ca486]{line-height:1;font-size:250px;font-weight:bolder;color:#2d8cf0}.error-code span[data-v-6c9ca486]{color:#00a854}.error-desc[data-v-6c9ca486]{font-size:30px;color:#777}.error-handle[data-v-6c9ca486]{margin-top:30px;padding-bottom:200px}.error-btn[data-v-6c9ca486]{margin-left:100px}", ""]);

// exports


/***/ }),

/***/ "MWvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        }
    }
});

/***/ }),

/***/ "VdfP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("MWvL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ca486_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("VhG4");
function injectStyle (ssrContext) {
  __webpack_require__("1i72")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9ca486"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ca486_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VhG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"error-desc"},[_vm._v("啊哦~ 你所访问的页面不存在")]),_vm._v(" "),_c('div',{staticClass:"error-handle"},[_c('router-link',{attrs:{"to":"/"}},[_c('el-button',{attrs:{"type":"primary","size":"large"}},[_vm._v("返回首页")])],1),_vm._v(" "),_c('el-button',{staticClass:"error-btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.goBack}},[_vm._v("返回上一页")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-code"},[_vm._v("4"),_c('span',[_vm._v("0")]),_vm._v("4")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.a317c9d0684ec848e82a.1704417532656.js